import { useCurrentSessionContext } from "@/context/currentSessionContext";

const ignoreLogs = [
  "MUI: There are multiple `InputBase` components inside a FormControl.",
  "NotSupportedError: Failed to execute 'define' on 'CustomElementRegistry':",
  "@firebase/firestore: Firestore (9.9.0)",
  "Warning: Smile: Support for defaultProps will be removed from function components in a future major release",
  "Warning: SnackbarAction: `key` is not a prop. Trying to access it will result in `undefined` being returned.",
  "Warning: %s: Support for defaultProps will be removed from function components in a future major release",
  "Warning: %s: `key` is not a prop. Trying to access it will result in `undefined` being returned",
  "Warning: React does not recognize the `%s` prop on a DOM element. If you intentionally want it to appear in the DOM as a custom attribute, spell it as lowercase `%s` instead. If you accidentally passed it from a parent component, remove it from the DOM element.%s drawerWidth",
]
function sendLogToServer(logEntry: LogEntry) {
  fetch('/api/client-log', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(logEntry),
  });
}

interface LogEntry {
  message: string;
  level: string;
  count: number;
  timestamp: string;
  url: string;
  user: string;
  queryParams: Record<string, string>;
}

let logBuffer: LogEntry[] = [];
let bufferTimeout: number | null = null;  // Cambiado a number para window.setTimeout
const BUFFER_SIZE = 10;
const BUFFER_TIMEOUT = 5000; // 10 segundos

function sendBufferedLogs() {
  if (logBuffer.length > 0) {
    logBuffer.forEach(entry => {
      sendLogToServer(entry);
    });
    logBuffer = [];
  }
  if (bufferTimeout) {
    window.clearTimeout(bufferTimeout);  // Limpiamos el timeout existente
    bufferTimeout = null;
  }
}

const getUrlParams = () => {
  if (typeof window === 'undefined') return {};
  
  const urlParams = new URLSearchParams(window.location.search);
  const params: Record<string, string> = {};
  
  urlParams.forEach((value, key) => {
    params[key] = value;
  });
  
  return {
    url: window.location.pathname,
    queryParams: params
  };
};

function addToBuffer(message: string, level: string, user?: string) {
  const urlInfo = getUrlParams();
  const existingEntry = logBuffer.find(entry => entry.message === message && entry.level === level);
  
  if(message.toLowerCase().includes("refresh")) return;
  if (existingEntry) {
    existingEntry.count++;
  } else {
    logBuffer.push({
      message,
      level,
      count: 1,
      timestamp: new Date().toISOString(),
      url: urlInfo.url || '',
      queryParams: urlInfo.queryParams || {},
      user: user || ''
    });
  }

  if (logBuffer.length >= BUFFER_SIZE) {
    sendBufferedLogs();
  }

  // Resetear el timeout existente antes de crear uno nuevo
  if (bufferTimeout) {
    window.clearTimeout(bufferTimeout);
  }
  bufferTimeout = window.setTimeout(sendBufferedLogs, BUFFER_TIMEOUT);
}

const getSession = () => {
  if (typeof window === 'undefined') return null;
  const storedData = sessionStorage.getItem('currentSession');
  return storedData ? JSON.parse(storedData) : null;
};

export function initializeLogCollector() {
  console.log('Log collector initialized');
  const session = getSession();

  const consoleFunctions = ['log', 'error', 'trace', 'warn', 'info', 'debug', 'group', 'groupEnd'];
  const onlyLogs = [ 'error', 'warn', 'info', 'debug'];
  // Almacenar las funciones originales
  const originalConsole: Record<string, Function> = {};

  consoleFunctions.forEach((funcName) => {
    // Guardar la referencia a la función original de console
    originalConsole[funcName] = (console as any)[funcName];

    // Sobrescribir la función de console
    (console as any)[funcName] = function (...args: any[]) {
      // Llamar a la función original
      originalConsole[funcName]?.apply(console, args);

      // Unir el mensaje y enviarlo al servidor
      const logMessage = args.map(arg => typeof arg === 'string' ? arg : JSON.stringify(arg)).join(' ');
      if (logMessage.trim() !== '' && !ignoreLogs.some(ignoreLog => logMessage.includes(ignoreLog))) {
        if (onlyLogs.includes(funcName)) {
          addToBuffer(logMessage, funcName, session?.user?.login);
        }else{
          addToBuffer(logMessage, 'info', session?.user?.login);
        }
      }
    };
  });
}